/* eslint-disable */
import React from 'react'
import {Checkbox, message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import MESSANGER from '../BaseComponent/MESSANGER'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import $ from 'jquery'
import FromToPicker from '../BaseComponent/FromToPicker'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'

class ReceivedMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      receiveMessage: [],
      printInfo: [],
      countAll: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',
      isBroadcast: false,
      companyMessage: false,
      fromDate: '',
      toDate: '',
      modalOpenMessage: false,
      seenObject: {},
      modalReply: false,
      checkAll: false,
      templates: [],

      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'عنوان',
          value: 'messageTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: ' متن',
          value: 'messageContent',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ارسال کننده',
          value: 'personSenderName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'زمان ارسال پیام',
          value: 'sendTime',
          sorted: true,
          direction: null,
          sortable: true
        },

        {
          name: 'زمان دریافت پیام',
          value: 'receiveTime',
          sorted: true,
          direction: null,
          sortable: true
        },

        {
          name: 'زمان مشاهده پیام',
          value: 'seenTime',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'ارسال به همه',
          value: 'broadCast',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'مشاهده',
          value: 'seen',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت',
          value: 'enabled',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: '‍پاسخ',
          value: 'answer',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  getAllReceiveMessage = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    http
      .get(`${MESSANGER.MESSAGING_REPORT_COMPANY_RECEIVED}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          // alert(JSON.stringify(response.data))
          this.setState({
            receiveMessage: response.data.object.result,
            countAll: response.data.object.countAll
          })
          $('.showBaseTable,.print').fadeIn()
        } else {
          $('.showBaseTable,.print').fadeOut()

          // message.error(response.data.description)
          this.setState({
            receiveMessage: []
          })
        }
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAllReceiveMessage(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAllReceiveMessage(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAllReceiveMessage(false)
    }
  }

  onResultFetched(data) {
    this.setState({
      receiveMessage: data
    })
  }

  changeDropDown(data) {
    this.setState({
      receiveMessage: data,
      lengthProducts: this.state.countAll
    })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }
  پ

  componentDidMount() {
    this.getAllReceiveMessage(false)

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')

    http.get(`${MESSANGER.MESSAGING_TYPE_LIST_TEMPLATE}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          templates: response.data.object
        })
      } else {
        this.setState({
          templates: []
        })
      }
    })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    let minSendTime = this.state.fromDate
    let maxSendTime = this.state.toDate
    let broadcast = document.getElementById('broadcast').value
    let messageTitle = document.getElementById('messageTitle').value.trim()
    let messageContent = document.getElementById('messageContent').value.trim()
    let companyMessage = document.getElementById('companyMessage').value

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (minSendTime !== '') {
      filter.minSendTime = minSendTime
    }
    if (maxSendTime !== '') {
      filter.maxSendTime = maxSendTime
    }
    if (broadcast !== '' && broadcast.length) {
      filter.broadcast = broadcast
    }
    if (messageTitle !== '' && messageTitle.length) {
      filter.messageTitle = messageTitle
    }
    if (messageContent !== '' && messageContent.length) {
      filter.messageContent = messageContent
    }
    if (companyMessage !== '' && companyMessage.length) {
      filter.companyMessage = companyMessage
    }
    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getAllReceiveMessage(false)
        }
      )
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`${MESSANGER.MESSAGING_REPORT_COMPANY_RECEIVED}`, {
        params: filter
      })
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['sendTime'] = jMoment(excelReport[i]['sendTime']).format('jYY/jMM/jDD HH:mm')
            excelReport[i]['receiveTime'] = jMoment(excelReport[i]['receiveTime']).format('jYY/jMM/jDD HH:mm')
            excelReport[i]['seenTime'] = jMoment(excelReport[i]['seenTime']).format('jYY/jMM/jDD HH:mm')

            if (excelReport[i]['broadcast']) {
              excelReport[i]['broadcast'] = 'بله'
            } else {
              excelReport[i]['broadcast'] = 'خیر'
            }

            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)

    http
      .get(`${MESSANGER.MESSAGING_REPORT_COMPANY_RECEIVED}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  getMessage = (messageId) => {
    let data = {
      messageId
    }
    http.post(`${MESSANGER.MESSAGING_OPERATION_COMPANY_GET}`, data, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          seenObject: response.data.object,
          modalOpenMessage: !this.state.modalOpenMessage
        })
        this.getAllReceiveMessage()
      } else {
        this.setState({
          modalOpenMessage: false,
          seenObject: {}
        })
      }
    })
  }
  toggleOpenMessage = () => {
    this.setState({
      modalOpenMessage: !this.state.modalOpenMessage
    })
  }
  closeMessage = () => {
    this.toggleOpenMessage()
  }

  changeCheckAll = (e) => {
    this.setState({
      checkAll: e.target.checked
    })
  }

  changeTemp(e) {
    let target = e.target
    let value = target.value
    if (value === '') {
      this.setState({
        title: '',
        content: ''
      })
    } else {
      this.setState({
        title: target.options[target.selectedIndex].getAttribute('data-title'),
        content: target.options[target.selectedIndex].getAttribute('data-content')
      })
    }
  }
  changeField(e) {
    let target = e.target
    let name = target.name
    let value = target.value
    this.setState({
      [name]: value
    })
  }

  reply = (messageId, personSenderId, messageContent) => {
    this.setState({
      messageId,
      personSenderId,
      messageContent,
      modalReply: !this.state.modalReply,
      title: '',
      content: ''
    })
  }
  toggleReply = () => {
    this.setState({
      modalReply: !this.state.modalReply,
      messageId: '',
      personSenderId: '',
      title: '',
      content: '',
      messageContent: ''
    })
  }
  closeReply = () => {
    this.toggleReply()
  }
  sendReply = () => {
    let {messageId, personSenderId, checkAll, title, content} = this.state

    let titleError = false
    let contentError = false
    let formError = false

    if (title === '') {
      message.error('عنوان  را مشخص کنید')
      titleError = true
      formError = true
    } else {
      if (!titleError) {
        this.setState({
          error: ''
        })
      }
    }
    if (content === '') {
      message.error(' پیام را مشخص کنید')
      contentError = true
      formError = true
    } else {
      if (!contentError) {
        this.setState({
          error: ''
        })
      }
    }
    if (!formError) {
      let data = {
        title,
        content,
        broadcast: checkAll,
        receiverId: this.state.checkAll ? undefined : personSenderId,
        replyId: messageId
      }
      http.post(`${MESSANGER.MESSAGING_OPERATION_COMPANY_SEND}`, data, {}).then((response) => {
        if (response.data.error === null) {
          message.success('پیام با موفقیت ارسال شد')
          this.toggleReply()
        } else {
        }
      })
    }
  }

  activate = (messageId, enabled) => {
    if (!enabled) {
      let data = {
        enabled: true,
        messageId
      }
      http.post(`${MESSANGER.MESSAGING_OPERATION_COMPANY_EDIT_STATUS}`, data, {}).then((response) => {
        if (response.data.error === null) {
          this.getAllReceiveMessage()
        } else {
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
    } else {
      let data = {
        enabled: false,
        messageId
      }
      http.post(`${MESSANGER.MESSAGING_OPERATION_COMPANY_EDIT_STATUS}`, data, {}).then((response) => {
        if (response.data.error === null) {
          this.getAllReceiveMessage()
        } else {
        }
      })
    }
  }

  render() {
    let {pageNumber, pageSize, lengthProducts} = this.state
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let printCol = [
      'ردیف',
      'عنوان',
      'متن',
      'ارسال کننده',
      'زمان ارسال ',
      'زمان دریافت',
      'زمان مشاهده',
      'ارسال به همه',
      'وضعیت'
    ]
    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش پیام های دریافت شده"
              headerColSpan={9}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={7}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((message, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{message.messageTitle}</td>
                  <td>{message.messageContent}</td>
                  <td>{message.personSenderName}</td>
                  <td>{jMoment(message.sendTime).format('jYY/jMM/jDD HH:mm')}</td>
                  <td>
                    {message.receiveTime === null ? '-' : jMoment(message.receiveTime).format('jYY/jMM/jDD HH:mm')}
                  </td>
                  <td>{message.seenTime === null ? '-' : jMoment(message.seenTime).format('jYY/jMM/jDD HH:mm')}</td>
                  <td className="confirmIgnor">{message.broadCast ? 'بله' : 'خیر'}</td>
                  <td className="confirmIgnor">{message.enabled ? 'فعال' : 'غیرفعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش پیام های دریافت شده.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'messageTitle'}
                field={'messageTitle'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'messageContent'}
                field={'messageContent'}
                title={'متن'}
                width="500px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'personSenderName'}
                field={'personSenderName'}
                title={'ارسال کننده'}
                width="500px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'sendTime'}
                field={'sendTime'}
                title={'زمان ارسال پیام'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'receiveTime'}
                field={'receiveTime'}
                title={'زمان دریافت پیام'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'seenTime'}
                field={'seenTime'}
                title={'زمان مشاهده پیام'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'broadcast'}
                field={'broadCast'}
                title={'ارسال به همه'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>پیام رسان</li>
            <li>پیام های دریافت شده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/messanger/report/received'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ ارسال از"
                  toLabel="تاریخ ارسال تا"
                  defaulValue={false}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>عنوان پیام</label>
                  <input className="form-control" id="messageTitle" type="text" />
                </div>
                <div className="formComponent">
                  <label>متن پیام</label>
                  <input className="form-control" id="messageContent" type="text" />
                </div>

                <div className="formComponent">
                  <label>پیام سراسری</label>
                  <select className="form-control" id="broadcast">
                    <option value="">------</option>
                    <option value={true}>بله</option>
                    <option value={false}>خیر</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>ارسال از سمت : </label>
                  <select className="form-control" id="companyMessage">
                    <option value="">------</option>
                    <option value={true}>شرکت</option>
                    <option value={false}>رساننده</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.receiveMessage.map((message, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{message.messageTitle}</td>
                      <td>{message.messageContent.substr(0, 5) + '......'}</td>
                      <td>{message.personSenderName}</td>
                      <td>{jMoment(message.sendTime).format('jYY/jMM/jDD HH:mm')}</td>
                      <td>
                        {message.receiveTime === null ? '-' : jMoment(message.receiveTime).format('jYY/jMM/jDD HH:mm')}
                      </td>
                      <td>{message.seenTime === null ? '-' : jMoment(message.seenTime).format('jYY/jMM/jDD HH:mm')}</td>
                      <td className="confirmIgnor">
                        {message.broadCast ? (
                          <img src={require('../../image/confirm.svg')} alt={'confirm'} />
                        ) : (
                          <img src={require('../../image/ignor.svg')} alt={'ignor'} />
                        )}
                      </td>
                      <td>
                        <button onClick={() => this.getMessage(message.messageId)}>
                          <img src={require('../../image/eye.svg')} alt="see" />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.activate(message.messageId, message.enabled)}>
                          {message.enabled ? (
                            <img src={require('../../image/on.svg')} alt="active" title={'فعال'} />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="deactive" title="غیر فعال" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => this.reply(message.messageId, message.personSenderId, message.messageContent)}
                        >
                          <img src={require('../../image/reply.svg')} alt="reply" title={'پاسخ'} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalOpenMessage} toggle={this.toggleOpenMessage} size="md">
          <ModalHeader toggle={this.toggleOpenMessage}>مشاهده پیام</ModalHeader>
          <ModalBody>
            <div className="commentCrm">
              <div className="formComponent">
                <label>عنوان : </label>
                <p>{this.state.seenObject.title}</p>
              </div>
              <div className="formComponent">
                <label>متن : </label>
                <p>{this.state.seenObject.body}</p>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.closeMessage}>
              بستن
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalReply} toggle={this.toggleReply} size="md">
          <ModalHeader toggle={this.toggleReply}>پاسخ پیام</ModalHeader>
          <ModalBody>
            <div className="commentCrm">
              <div className="formComponent">
                <label>پاسخ به پیام : </label>
                <p>{this.state.messageContent}</p>
              </div>
            </div>

            <div className="modalForm">
              <div className="formComponent">
                <Checkbox defaultChecked={this.state.checkAll} onChange={this.changeCheckAll}>
                  ارسال به همه
                </Checkbox>
              </div>
              <div className="formComponent">
                <label>پیام های آماده : </label>
                <select className="form-control" onChange={this.changeTemp.bind(this)}>
                  <option value="">-----</option>
                  {this.state.templates.map((temp, index) => (
                    <option key={index} value={temp.id} data-content={temp.content} data-title={temp.title}>
                      {temp.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="formComponent">
                <label>
                  عنوان : <span className="requireFiled">*</span>
                </label>
                <input
                  typeof="text"
                  value={this.state.title}
                  name={'title'}
                  onChange={this.changeField.bind(this)}
                  className="form-control"
                />
              </div>

              <div className="formComponent">
                <label>
                  پیام : <span className="requireFiled">*</span>
                </label>
                <textarea
                  className="form-control"
                  id="content"
                  name="content"
                  onChange={this.changeField.bind(this)}
                  value={this.state.content}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.sendReply}>
              ارسال پاسخ
            </button>
            <button className="cancelBtnModal" onClick={this.closeReply}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default ReceivedMessage
